import { render } from "./CardHistoryDialog.vue?vue&type=template&id=67c87a7d"
import script from "./CardHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CardHistoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__